var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 0.5H1.75C1.125 0.5 0.5 1.125 0.5 1.75V14.25C0.5 14.875 1.125 15.5 1.75 15.5H14.25C14.875 15.5 15.5 14.875 15.5 14.25V1.75C15.5 1.125 14.875 0.5 14.25 0.5ZM9.66667 6.75H6.33333H3V8.83333V10.9167V13H6.33333H9.66667H13V10.9167V8.83333V6.75H9.66667ZM4.25 8H5.5V9.25H4.25V8ZM5.5 10.5H4.25V11.75H5.5V10.5ZM6.75 10.5H11.75V11.75H6.75V10.5ZM11.75 8H6.75V9.25H11.75V8Z",
    fill: "#27A590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.778618742803c49ab96ccba8fcc7187a.svg";
export { ForwardRef as ReactComponent };